import { render, staticRenderFns } from "./CmsCategorySelect.vue?vue&type=template&id=3b621921&scoped=true&"
import script from "./CmsCategorySelect.vue?vue&type=script&lang=js&"
export * from "./CmsCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b621921",
  null
  
)

export default component.exports